'use strict';

import template from '../../templates/users/Main.ejs';
import InviteLegacyTemplate from '../../templates/users/InviteLegacy.ejs';
import UserView from './User.js';
import PaginatedList from 'commons/views/PaginatedList.js';
import loader from 'helpers/loader';
import Loader from "../../../helpers/loader";
import User from 'newModels/user.js';
import Alerts from 'lib/alerts';

module.exports = PaginatedList.extend({
    events: function() {
        return Object.assign({
            'click .js-invite-legacy-user': 'inviteLegacyUser'
        }, PaginatedList.prototype.events.apply(this));
    },

    views: [],

    initialize: function(options) {
        this.options = _.defaults(options || {}, {});

        this.views = [];

        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.stopLoader = loader.startFullPage(this.$('table'));

        return this;
    },

    inviteLegacyUser: function(ev) {
        const stopLoader = Loader.startFullScreen(ev.currentTarget);
        const email = this.$('.js-email').val();
        const name = this.$('.js-name').val();

        User.inviteLegacyUser(name, email)
            .then(() => {
                stopLoader();
                this.$('#invite-modal').modal('hide');
                return Alerts.show('success', {
                    title: 'Legacy User Invitation',
                    text: 'Invitation successfully sent!'
                });
            })
            .catch(err => {
                stopLoader();
                this.$('#invite-modal').modal('hide');
                return Alerts.show('error', {
                    title: 'Legacy User Invitation not sent',
                    text: err
                });
            });
    },

    render: function() {
        let sortClass = this.collection.getSort().order === 'ascending' ?
            'footable-sorted-desc' : 'footable-sorted';

        this.$el.html(template({
            searchTerm: this.collection.getSearchTerm(),
            total: this.collection.length,
            pagination: this.collection.getPaginationInfo(),
            sort: this.collection.getSort(),
            inviteModal: InviteLegacyTemplate()
        }));

        this.collection.forEach(model => {
            this.views.push(new UserView({model}));
            this.$('.js-users').append(_(this.views).last().$el);
        });

        this.$('.footable-sortable')
            .removeClass('footable-sorted-desc')
            .removeClass('footable-sorted');

        this.$('[data-sort="' + this.collection.getSort().key + '"]')
            .addClass(sortClass);

        this.stopLoader();
        return this;
    },

    // TODO the brainchild of Artem, wouldn't it be nicer to use a qs?
    navigate() {
        app.mainRouter.navigate(
            'users' +
            '/' + this.collection.getSort().key +
            '/' + this.collection.getSort().order +
            '/' + (this.collection.getSearchTerm() || '__all'),
            {trigger: true}
        );
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/users/Main.js